import React, { useContext, useState } from "react";
import { TextField, MenuItem,Button } from "@mui/material";
import { ContextData } from "../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../BaseURL";
import SoundAlert from "../../../../../routes/SoundAlert";


function Origin({ formData, handleChange }) {


  const {UserTokens,ReloadBioForms,setReloadBioForms} = useContext(ContextData)
  const [HomeAddress,setHomeAddress] = useState(formData.origin.home_address || "")
  const [city_town,setCityTown] = useState(formData.origin.city_town || "")
   

    // Handle data to server if succeed
 const handleSubmit = (va,e) => {
    
  e.preventDefault()

   if(va === "city_town"){
    if ( city_town.trim() === "" ) {
          
      toast.error('Please fill in all required fields.');
      SoundAlert("error")
        return
    }
   }

   if(va === "home_address"){ 
    if ( HomeAddress.trim() === "" ) {
        SoundAlert("error")
      toast.error('Please fill in all required fields.');
        return
    }
   }
  

   
    const data = {
      home_address: HomeAddress,
      user_token: UserTokens,
      city_town: city_town
    }
    
    axios.put(`${baseUrl}/auth/demography_update`,data,{
      withCredentials: true,
      headers: {
        'Accept' : 'application/json'
      }}).then(res=>{

        
       if(res.data.status){
        toast.success(res.data.textStatus);
         setReloadBioForms(!ReloadBioForms)
          }
      

      }).catch(err=> {
          if(err){
              
            toast.error(err.message)
            console.log(err)
            return

          }   
      })


 
}



  return (
    <div>


      <TextField
        label="State Of Origin"
        name="state_of_origin"
        value={formData.origin.state_of_origin}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        disabled
      />
      <TextField
        label="Local Government"
        name="local_government"
        value={formData.origin.local_government}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        disabled
      />

      <TextField
        label="Home Address"
        name="home_address"
        value={HomeAddress}
        onChange={(e)=> setHomeAddress(e.target.value)}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              color="secondary"
             onClick={(e) => handleSubmit("home_address",e)}
               
            >
              Save
            </Button>
          )
        }}
      />


         <TextField
        label="City/Town"
        name="city_town"
        value={city_town}
        onChange={(e)=> setCityTown(e.target.value)}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              color="secondary"
             onClick={(e) => handleSubmit("city_town",e)}
               
            >
              Save
            </Button>
          )
        }}
      />
     

    </div>
  );
}

export default Origin;
